// extracted by mini-css-extract-plugin
export default {"form_wrapper":"Loan_Form_form_wrapper__DIicd","expand":"Loan_Form_expand__fLmsg","submit_btn":"Loan_Form_submit_btn__j-EGU"};